<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Bulk Notification Trigger">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'notficationTrigger' }">
            <v-btn elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="3" sm="4" class="pl-6 pr-6">
              <v-list-item class="my-6" tile>
                <v-autocomplete
                  key="id"
                  label="Select ModuleName"
                  :items="moduleNames"
                  v-model="selectedModuleName"
                  required
                  item-text="name"
                  item-value="name"
                  :hide-details="true"
                  @change="onModuleNameChange"
                >
                </v-autocomplete>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="3" sm="4" class="pl-6 pr-6">
              <v-list-item class="my-6" tile>
                <v-autocomplete
                  key="name"
                  label="Select UserType"
                  :items="usertype"
                  v-model="selectedUsertype"
                  required
                  item-text="name"
                  item-value="name"
                  :hide-details="true"
                >
                </v-autocomplete>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center mb-4">
              <v-text-field
                v-model="title"
                label="Notification Title"
                required
                class="mb-4"
              />
              <v-text-field
                v-model="body"
                label="Notification Description"
                required
                class="mb-4"
              />
              <!-- Hide moduleURL/imageURL if available, show refParameter instead -->
                <v-text-field
                  v-if="!moduleInfo.isPageURLAvailable"
                  v-model="moduleURL"
                  label="Module URL"
                  class="mb-2"
                />
                <v-alert
                  v-if="!moduleInfo.isPageURLAvailable"
                  type="info"
                  dense
                  outlined
                  class="mb-4"
                >
                  Note: Add <strong>ref=notif_push_&lt;value&gt;</strong> at the end of the Module URL when providing a ref value.
                </v-alert>
                <v-text-field
                  v-if="!moduleInfo.isAvailable"
                  v-model="imageURL"
                  label="Notification image URL"
                  class="mb-4"
                />
                <v-text-field
                  v-if="moduleInfo.isPageURLAvailable"
                  v-model="refParameter"
                  label="Ref Parameter"
                  class="mb-4"
                  required
                />
                  <v-alert
                  v-if="moduleInfo.isPageURLAvailable"
                  type="info"
                  dense
                  outlined
                  class="mb-4"
                  >
                  Please begin the parameter with <strong>notif_push_</strong> before adding the value.
                  </v-alert>
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triggerDate"
                    label="Trigger Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="mb-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="triggerDate"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                ref="timeMenu"
                v-model="timeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="triggerTime"
                    label="Trigger Time"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="mb-4"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="triggerTime"
                  @input="timeMenu = false"
                  format="24hr"
                ></v-time-picker>
              </v-menu>
              <v-btn color="primary" @click="triggerDummyNotification">Trigger Notification</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'bulkNotification',
  components: { MaterialCard },
  data () {
    return {
      moduleNames: [
        // { id: 1, name: 'ReportCardStack' },
        // { id: 2, name: 'GallaryStack' },
        // { id: 3, name: 'ClassDiaryStack' },
        // { id: 4, name: 'Child_Details' },
        // { id: 5, name: 'OnlineClassStack' },
        // { id: 6, name: 'EventCalendarStack' },
        // { id: 7, name: 'MyHomeworkStack' },
        // { id: 8, name: 'FeeDetailsStack' },
        // { id: 9, name: 'AnnouncementsStack' },
        // { id: 10, name: 'communicationAnnouncementsStack' },
        // { id: 11, name: 'personalMessageStack' },
        { id: 12, name: 'WorkSheetStack' },
        // { id: 13, name: 'SummerCampStack' },
        { id: 14, name: 'IntelliSkillsBooksStack' },
        { id: 15, name: 'RewardsStack' },
        { id: 16, name: 'EduMagStack' },
        { id: 17, name: 'PreschoolLocatorStack' },
        { id: 18, name: 'ShopStack' },
        { id: 19, name: 'IntelliSkillsToysStack' },
        // { id: 20, name: 'MyPreschoolModulesStack' },
        { id: 21, name: 'IntelliBabyStack' },
        { id: 22, name: 'IntellitotsStack' },
        // { id: 23, name: 'DaycareStack' },
        { id: 24, name: 'EventsStack' },
        { id: 25, name: 'RadioStack' }
      ],
      selectedModuleName: null,
      usertype: [
        { name: 'ENROLLED' },
        { name: 'REGISTERED' }
        // { name: 'NON-REGISTERED' }
      ],
      selectedUsertype: null,
      title: null,
      body: null,
      referenceType: 'number',
      referenceNumber: null,
      referenceUserId: null,
      imageURL: null,
      moduleURL: null,
      triggerDate: null,
      triggerTime: null,
      dateMenu: false,
      timeMenu: false,
      refParameter: null,
      moduleInfo: {
        isAvailable: false,
        imageURL: null,
        isPageURLAvailable: false,
        pageURL: null
      },
      isLoading: false
    }
  },
  methods: {
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    resetFilters () {
      this.selectedZones = ''
      this.selectedCenterIds = []
      this.selectedStatus = ''
      this.students = []
      this.flag = false
      this.flagStatus = false
    },
    async onModuleNameChange (moduleName) {
      if (!moduleName) {
        this.moduleInfo = {
          isAvailable: false,
          imageURL: null,
          isPageURLAvailable: false,
          pageURL: null
        }
        return
      }
      this.isLoading = true
      try {
        const res = await http.get(`${constants.API_URL}/api/admin/app-notification/check-module-image`, {
          params: { moduleName }
        })
        if (res && res.data.success) {
          this.moduleInfo = {
            isAvailable: res.data.isAvailable,
            imageURL: res.data.imageURL,
            isPageURLAvailable: res.data.isPageURLAvailable,
            pageURL: res.data.pageURL
          }
        } else {
          this.moduleInfo = {
            isAvailable: false,
            imageURL: null,
            isPageURLAvailable: false,
            pageURL: null
          }
        }
      } catch (err) {
        this.moduleInfo = {
          isAvailable: false,
          imageURL: null,
          isPageURLAvailable: false,
          pageURL: null
        }
      }
      this.isLoading = false
    },
    async triggerDummyNotification () {
      // Trim all relevant fields
      if (typeof this.title === 'string') this.title = this.title.trim()
      if (typeof this.body === 'string') this.body = this.body.trim()
      if (typeof this.triggerDate === 'string') this.triggerDate = this.triggerDate.trim()
      if (typeof this.triggerTime === 'string') this.triggerTime = this.triggerTime.trim()
      if (typeof this.imageURL === 'string') this.imageURL = this.imageURL.trim()
      if (typeof this.moduleURL === 'string') this.moduleURL = this.moduleURL.trim()
      if (typeof this.refParameter === 'string') this.refParameter = this.refParameter.trim()

      // Validate all required fields strictly
      if (!this.selectedModuleName || (typeof this.selectedModuleName === 'string' && !this.selectedModuleName.trim())) {
        this.errMsg('Please select Module Name')
        return
      }
      if (!this.selectedUsertype || (typeof this.selectedUsertype === 'string' && !this.selectedUsertype.trim())) {
        this.errMsg('Please select User Type')
        return
      }
      if (!this.title || !this.title.trim()) {
        this.errMsg('Please enter Notification Title')
        return
      }
      if (!this.body || !this.body.trim()) {
        this.errMsg('Please enter Notification Description')
        return
      }
      // If moduleURL is required, validate strictly
      if (!this.moduleInfo.isPageURLAvailable && (!this.moduleURL || !this.moduleURL.trim())) {
        this.errMsg('Please enter Module URL')
        return
      }
      // If imageURL is required, validate strictly
      if (!this.moduleInfo.isAvailable && (!this.imageURL || !this.imageURL.trim())) {
        this.errMsg('Please enter Notification image URL')
        return
      }
      // If refParameter is required, validate strictly
      if (this.moduleInfo.isPageURLAvailable && (!this.refParameter || !this.refParameter.trim())) {
        this.errMsg('Please enter Ref Parameter')
        return
      }
      if (!this.triggerDate || !this.triggerDate.trim()) {
        this.errMsg('Please select Trigger Date')
        return
      }
      if (!this.triggerTime || !this.triggerTime.trim()) {
        this.errMsg('Please select Trigger Time')
        return
      }
      // Check if date and time is in future
      const selectedDateTime = new Date(`${this.triggerDate}T${this.triggerTime.length === 5 ? this.triggerTime + ':00' : this.triggerTime}`)
      const now = new Date()
      if (selectedDateTime <= now) {
        this.errMsg('Trigger Date and Time must be in the future')
        return
      }
      // Convert triggerTime from 'hh:mm' to 'hh:mm:ss' if needed
      let time = this.triggerTime
      if (/^\s*\d{2}:\d{2}\s*$/.test(time)) {
        time = time.replace(/\s/g, '') + ':00'
        this.triggerTime = time
      }
      if (!/^\d{2}:\d{2}:\d{2}$/.test(this.triggerTime)) {
        this.errMsg('Trigger Time must be in format hh:mm:ss')
        return
      }
      let imageURLToSend = this.imageURL
      let moduleURLToSend = this.moduleURL

      if (this.moduleInfo.isAvailable) {
        imageURLToSend = this.moduleInfo.imageURL
      }
      if (this.moduleInfo.isPageURLAvailable) {
        moduleURLToSend = this.moduleInfo.pageURL
      }

      // Append refParameter if needed
      if ((this.moduleInfo.isAvailable || this.moduleInfo.isPageURLAvailable) && this.refParameter && moduleURLToSend) {
        if (moduleURLToSend.includes('?')) {
          moduleURLToSend += `&ref=${encodeURIComponent(this.refParameter)}`
        } else {
          moduleURLToSend += `?ref=${encodeURIComponent(this.refParameter)}`
        }
      }

      // Build payload with only non-empty fields
      const payload = {
        triggerDate: this.triggerDate,
        triggerTime: this.triggerTime,
        type: 'IN_APP_N_PUSH',
        targetUsers: this.selectedUsertype,
        moduleName: this.selectedModuleName,
        moduleURL: moduleURLToSend || '',
        title: this.title,
        body: this.body
      }
      if (imageURLToSend && imageURLToSend.trim()) {
        payload.imageURL = imageURLToSend
      }

      // Prepare notification data for confirmation table
      const notificationData = [
        { label: 'Module Name', value: payload.moduleName },
        { label: 'User Type', value: payload.targetUsers },
        { label: 'Notification Title', value: payload.title },
        { label: 'Notification Description', value: payload.body },
        { label: 'Module URL', value: payload.moduleURL },
        { label: 'Image URL', value: payload.imageURL || (this.moduleInfo.isAvailable ? 'Available in constants' : '') },
        { label: 'Trigger Date', value: payload.triggerDate },
        { label: 'Trigger Time', value: payload.triggerTime }
      ].filter(item => item.value !== undefined && item.value !== '')

      // Dynamically generate HTML table for notification data
      const html = `
        <div style="max-width: 100%; overflow-x: auto;">
          <table style="width: 100%; min-width: 500px; text-align: left; border-collapse: collapse;">
        <tbody>
          ${notificationData.map(item =>
    `<tr>
          <td style="font-weight:bold;padding:4px 16px 4px 0;white-space:nowrap;">${item.label}</td>
          <td style="padding:4px 0;word-break:break-all;">${item.value}</td>
            </tr>`
  ).join('')}
        </tbody>
          </table>
        </div>
      `

      // Show confirmation popup with readable notification data
      this.$buefy.dialog.confirm({
        title: 'Confirm Notification',
        message: html,
        confirmText: 'Yes, Trigger',
        cancelText: 'Cancel',
        type: 'is-info',
        hasIcon: true,
        ariaRole: 'alertdialog',
        ariaModal: true,
        onConfirm: async () => {
          try {
            await http.post(`${constants.API_URL}/api/admin/app-notification/generic`, payload)
            this.$buefy.toast.open({
              message: 'Bulk notification triggered successfully!',
              type: 'is-success',
              duration: 5000,
              position: 'is-top-right'
            })
            this.resteForm()
          } catch (err) {
            this.errMsg(err.response?.data?.message || 'Failed to trigger notification')
          }
        },
        onCancel: () => {}
      })
    },
    resteForm () {
      this.selectedModuleName = null
      this.selectedUsertype = null
      this.title = null
      this.body = null
      this.imageURL = null
      this.moduleURL = null
      this.triggerDate = null
      this.triggerTime = null
      this.refParameter = null
      this.moduleInfo = {
        isAvailable: false,
        imageURL: null,
        isPageURLAvailable: false,
        pageURL: null
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.truncated-text {
    cursor: pointer;
}
</style>
